var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftPlug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 217,
    viewBox: "0 0 336 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3618 155.884C87.1866 155.884 105.2 148.887 120.058 134.774C137.804 117.892 148.076 93.8933 158.021 70.6691C169.246 44.4376 179.845 19.6353 199.229 13.4421C207.774 10.7029 215.516 11.6259 222.959 16.241C255.652 36.5771 268.038 117.564 268.157 118.368L279.204 116.731C278.668 113.187 265.894 29.8182 228.855 6.7726C218.612 0.400822 207.506 -0.939035 195.834 2.81258C171.598 10.554 160.016 37.6192 147.778 66.2922C128.722 110.805 109.041 156.837 40.4702 141.801L7.30115 131.082C4.35346 130.129 1.22712 131.737 0.274332 134.685C-0.678458 137.632 0.929368 140.759 3.87706 141.711L37.8202 152.669C47.5565 154.783 56.7569 155.884 65.3618 155.884Z",
    fill: "#525460"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.044 211.027L242.164 153.413C238.055 133.523 249.637 113.753 269.02 107.59C290.666 100.712 313.682 113.396 319.429 135.369L334.018 191.256L254.044 211.027Z",
    fill: "#D83E59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.044 211.027L242.164 153.413C238.055 133.523 249.637 113.753 269.02 107.59C290.666 100.712 313.682 113.396 319.429 135.369L334.018 191.256L254.044 211.027Z",
    fill: "url(#paint0_linear_731_6446)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.073 212.545C255.354 217.845 274.499 217.786 296.86 212.396C319.22 207.007 336.311 198.343 335.031 193.043C333.75 187.743 314.605 187.802 292.245 193.192C269.884 198.581 252.793 207.245 254.073 212.545Z",
    fill: "#D3D3D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.338 196.914C302.011 198.7 305.227 200.784 309.484 201.529C313.742 202.303 317.464 201.469 317.791 199.683C318.119 197.896 314.903 195.812 310.646 195.068C306.388 194.294 302.666 195.127 302.338 196.914Z",
    fill: "#525460"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.171 205.549C273.844 207.335 277.06 209.419 281.317 210.164C285.575 210.938 289.297 210.104 289.624 208.318C289.952 206.531 286.736 204.447 282.479 203.703C278.221 202.928 274.499 203.762 274.171 205.549Z",
    fill: "#525460"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.833 114.319C289.833 114.319 307.073 120.601 312.551 138.615C318.03 156.629 322.734 179.764 322.734 179.764L307.073 180.151L289.833 114.319Z",
    fill: "#D53B5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.678 93.9229L266.341 108.453L277.298 105.922L274.678 93.9229Z",
    fill: "#525460"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_731_6446",
    x1: 241.338,
    y1: 158.371,
    x2: 333.817,
    y2: 158.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D83E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32C66"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPlug);
export default __webpack_public_path__ + "static/media/LeftPlug.c17c034b64126e20d3818d48ee11747a.svg";
export { ForwardRef as ReactComponent };